import { baseQuery, endpoints, formatErrors } from "utils/api/endpoints";
import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice, createApi } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { QuickRechargeState, VerifyQrOtpResponse } from "./types";

export const initialState: QuickRechargeState = {};

const slice = createSlice({
  name: "quickRecharge",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: "quickRechargeApi",
  baseQuery,
  endpoints: (build) => ({
    sendQrOtp: build.mutation<any, any>({
      query: (body) => {
        return {
          ...endpoints.sendQrOtp,
          body,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    verifyQrOtp: build.mutation<
      { data: VerifyQrOtpResponse },
      { otp: string; phone: string }
    >({
      query: (body) => {
        return {
          ...endpoints.verifyQrOtp,
          body,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    renewPlan: build.mutation<any, any>({
      query: (body) => {
        return {
          ...endpoints.renewPlan,
          body,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    createAddon: build.mutation<any, any>({
      query: (body) => {
        return {
          ...endpoints.createAddon,
          body,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    buyDataTopUp: build.mutation<any, any>({
      query: (body) => {
        return {
          ...endpoints.buyDataTopUp,
          body,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
  }),
});

export const { actions: quickRechargeActions } = slice;

export const useQuickRechargeSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return { actions: slice.actions, ...api };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useQuickRechargeSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
